module.exports = __webpack_public_path__ + "img/pic_suppay_googleplay@3x.38dc3507.png";